import { IntegrationSystem } from "../../types";
import { CleverReachConnectView } from "./ConnectView";
import { CleverReachSettingsView } from "./SettingsView";

export const CleverReachSystem: IntegrationSystem = {
  ConnectView: CleverReachConnectView,
  SettingsView: CleverReachSettingsView
};
